export const getFromStorage = (key) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
};

export const setToStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const removeFromStorage = (key) => {
    localStorage.removeItem(key);
};
export const clearStorage = () => {
    localStorage.clear();
};
